module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("SurveyJS Library - a sample survey below")]), _vm._v(" "), _c('survey', {
    attrs: {
      "survey": _vm.survey
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bc0fcb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Survey.vue
// module id = 370
// module chunks = 1